<template>
  <div class="space_dialog">
    <el-dialog class="qrcodeClass" title="" :visible.sync="qrcodeVisible" :show-close="false" :destroy-on-close="true"
      :close-on-click-modal="false" width="40rem" center @opened="qrcodeDialogOpen" @closed="qrcodeDialogClose">
      <!-- 二维码 -->
      <div id="qrcodeExport" @contextmenu.prevent="openQrcodeMenuMenu($event, 1)">
        <p :class="qrcodeTitle.length <= 16 ? 'qrcodeTitle' : 'qrcodeTitlea'">
          {{ qrcodeTitle }}
        </p>
        <div :class="qrcodeTitle.length <= 16 ? 'qrcodePic' : 'qrcodePica'">
          <div id="qrcode">
            <el-image :src="qrcodeLink" alt="" @contextmenu.prevent="openQrcodeMenuMenu($event, 2)">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </div>
        </div>
        <p class="qrcodeDetail">微信扫码进入纪念堂</p>

        <ul v-show="qrcodeMenuVisible" :style="{ left: qrcodeMenuLeft + 'px', top: qrcodeMenuTop + 'px' }"
          class="qrcodeMenu">
          <li @click="exportQrcodePicTimer">图片另存为</li>
        </ul>
      </div>

      <i class="qrcodeRadio upLeft"></i>
      <i class="qrcodeRadio upRight"></i>
      <i class="qrcodeRadio downLeft"></i>
      <i class="qrcodeRadio downRight"></i>
      <span class="qrcodeButton" @click="closeAll()"></span>
    </el-dialog>
    
    <!-- APP认领码 -->
    <el-dialog class="qrcodeClass" title="" :visible.sync="qrcodeVisibleClaimApp" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="40rem" center @opened="qrcodeDialogOpen"
      @closed="qrcodeDialogClose">
      <div class="qrcodeExportclaim">
        <el-image :src="qrcodeLink" alt="">
          <div slot="error" class="image-slot"></div>
        </el-image>
      </div>
      <i class="qrcodeRadio upLeft"></i>
      <i class="qrcodeRadio upRight"></i>
      <i class="qrcodeRadio downLeft"></i>
      <i class="qrcodeRadio downRight"></i>
      <span class="qrcodeButton" @click="closeAllClaimApp()"></span>
    </el-dialog>

    <!-- 认领码 -->
    <el-dialog class="qrcodeClass" title="" :visible.sync="qrcodeVisibleClaimAll" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="40rem" center @opened="qrcodeDialogOpen"
      @closed="qrcodeDialogClose">
      <div class="qrcodeExportclaim">
        <el-image :src="qrcodeLink" alt="">
          <div slot="error" class="image-slot"></div>
        </el-image>
      </div>
      <i class="qrcodeRadio upLeft"></i>
      <i class="qrcodeRadio upRight"></i>
      <i class="qrcodeRadio downLeft"></i>
      <i class="qrcodeRadio downRight"></i>
      <span class="qrcodeButton" @click="closeAllClaimAll()"></span>
    </el-dialog>

    <!-- 小程序认领码 -->
    <el-dialog class="qrcodeClass" title="" :visible.sync="qrcodeVisibleClaim" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="40rem" center @opened="qrcodeDialogOpen"
      @closed="qrcodeDialogClose">
      <div id="qrcodeExportclaim">
        <p :class="qrcodeTitle.length <= 16 ? 'qrcodeTitle' : 'qrcodeTitlea'">
          {{ qrcodeTitle }}
        </p>
        <div :class="qrcodeTitle.length <= 16 ? 'qrcodePic' : 'qrcodePica'">
          <div id="qrcode">
            <el-image :src="qrcodeLink" alt="">
              <div slot="error" class="image-slot"></div>
            </el-image>
          </div>
        </div>
        <p class="qrcodeDetail">长按识别成为纪念堂主办人</p>
      </div>
      <i class="qrcodeRadio upLeft"></i>
      <i class="qrcodeRadio upRight"></i>
      <i class="qrcodeRadio downLeft"></i>
      <i class="qrcodeRadio downRight"></i>
      <span class="qrcodeButton" @click="closeAllClaim()"></span>
    </el-dialog>

    <!-- 合成大图 -->
    <el-dialog class="dialog_ADImage" title="预览" :visible.sync="ADImageVisible" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="100rem">
      <div class="ADImage">
        <el-image style="width: 100%; height: 100%" fit="fill" :src="editADImageData.posterUrl"></el-image>
      </div>

      <div slot="footer" class="dialog-footer" v-if="isDownBig">
        <el-button @click="closeADImage()" style="width: 11.2rem">关闭</el-button>
        <el-button type="primary" @click="edit_ADImage" style="width: 11.2rem">调整文字</el-button>
      </div>
      <div v-if="!isDownBig" slot="footer" class="dialog-footer" style="height: 2rem"></div>
    </el-dialog>

    <!-- 修改大图文案 -->
    <el-dialog class="dialog_ADImage_edit" title="背景图片调整文字" :visible.sync="ADImageEditVisible" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="100rem">
      <el-form style="margin-left: 24rem">
        <el-form-item label-width="10rem" label="第一行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="editADImageData.first" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="10rem" label="第二行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="editADImageData.second" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="10rem" label="第三行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="editADImageData.third" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="10rem" label="第四行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="editADImageData.forth" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="getNewADImageCancel" :disabled="editADImageData.loading" style="width: 11.2rem">关闭
        </el-button>
        <el-button type="primary" @click="getNewADImage" :loading="editADImageData.loading" style="width: 13.2rem">生成并预览
        </el-button>
      </div>
    </el-dialog>

    <!-- 竖版合成大图 -->
    <el-dialog class="dialog_ADImage_code" title="预览" :visible.sync="ADImageVisibleCode" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="100rem">
      <div class="ADImage">
        <el-image style="width: 100%; height: 100%" fit="fill" :src="claimCodeData.posterUrl"></el-image>
      </div>

      <div slot="footer" class="dialog-footer" v-if="isDownBigCode">
        <el-button @click="closeADImageCode()" style="width: 11.2rem">关闭</el-button>
        <el-button type="primary" @click="edit_ADImage_another" style="width: 11.2rem">调整文字</el-button>
      </div>
      <div v-if="!isDownBigCode" slot="footer" class="dialog-footer" style="height: 2rem"></div>
    </el-dialog>

    <el-dialog class="dialog_ADImage_edit" title="背景图片调整文字" :visible.sync="ADImageEditVisibleCode" :show-close="false"
      :destroy-on-close="true" :close-on-click-modal="false" width="100rem">
      <el-form style="margin-left: 24rem">
        <el-form-item label-width="10rem" label="第一行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="claimCodeData.first" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="10rem" label="第二行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="claimCodeData.second" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="10rem" label="第三行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="claimCodeData.third" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="10rem" label="第四行文案:">
          <el-input placeholder="请输入相关信息" v-model.trim="claimCodeData.forth" maxlength="25"
            class="dialog_ADImage_edit_input" clearable></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="getNewADImageCancelCode" :disabled="claimCodeData.loading" style="width: 11.2rem">关闭
        </el-button>
        <el-button type="primary" @click="getNewADImageCode" :loading="claimCodeData.loading" style="width: 13.2rem">
          生成并预览</el-button>
      </div>
    </el-dialog>

    <el-dialog title="冻结访问码" width="61rem" :visible.sync="freezingVisitorDialog" :close-on-click-modal="false"
      :before-close="handleFreezingVisitorClose">
      <div class="dialog_body_create" style="margin-bottom: 3rem">
        <div class="cemetery_use">
          <div class="cemetery_use_title_a">
            <span style="color: #eb5454">*</span>请填写冻结理由：
          </div>
          <el-input class="search_input_big" type="textarea" v-model.trim="freezingVisitorText" placeholder="请输入内容"
            :rows="4" maxlength="100" resize="none"></el-input>
          <span class="search_input_big_number_b">{{ freezingVisitorText | remarkLength
          }}<span class="search_input_big_number_a">/100</span></span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button style="width: 10rem; margin-right: 1.5rem" plain @click="dialogFreezingVisitorTextCancel()">取消
        </el-button>
        <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
          @click="dialogFreezingVisitorTextSave()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="解除冻结访问码" width="129rem" :visible.sync="unfreezeDialog" :close-on-click-modal="false"
      :before-close="handleUnfreezeClose">
      <div class="dialog_body_create" style="margin-bottom: 3rem">
        <div class="unfreeze_title_all">
          <div class="unfreeze_title_all_text">冻结备注：</div>
          <div class="unfreeze_title_search_input_another">
            {{ visitorFrozenContentNew.visitorFrozenRemark }}
            <span class="search_input_big_number_another">{{ visitorFrozenContentNew.visitorFrozenRemark | remarkLength
            }}<span class="search_input_big_number_a">/100</span></span>
          </div>
        </div>

        <div class="unfreeze_middle">
          <div class="unfreeze_middle_title" style="margin-left: 1rem">
            冻结内容：
          </div>

          <div class="unfreeze_middle_content" style="margin-left: 1rem">
            <div class="unfreeze_middle_content_title" v-if="
              visitorFrozenContent.lifeTitle1 != undefined &&
              visitorFrozenContent.lifeTitle1 != ''
            ">
              {{ visitorFrozenContent.lifeTitle1 }}
            </div>
            <div v-html="visitorFrozenContent.lifeStory1" class="unfreeze_middle_content_text" v-if="
              visitorFrozenContent.lifeStory1 != undefined &&
              visitorFrozenContent.lifeStory1 != ''
            "></div>
            <div class="unfreeze_middle_content_title" v-if="
              visitorFrozenContent.lifeTitle2 != undefined &&
              visitorFrozenContent.lifeTitle2 != ''
            ">
              {{ visitorFrozenContent.lifeTitle2 }}
            </div>
            <div v-html="visitorFrozenContent.lifeStory2" class="unfreeze_middle_content_text" v-if="
              visitorFrozenContent.lifeStory2 != undefined &&
              visitorFrozenContent.lifeStory2 != ''
            "></div>
            <img class="unfreeze_middle_img" :src="visitorFrozenContent.coverUrl" alt=""
              style="margin-top: 2rem; margin-left: 1rem" mode="aspectFill" />
            <div class="v_template_imgs_a">
              <div class="v_template_item_a" v-for="(item, i) in visitorFrozenContent.photoList" :key="i"
                style="margin-left: 1rem">
                <img class="iv_template_a" alt="" :src="item.photoUrl" mode="aspectFill" />
              </div>
            </div>
          </div>

          <div class="unfreeze_middle_title" style="margin-left: 3rem">
            审核解冻内容：
          </div>

          <div class="unfreeze_middle_content" style="margin-left: 1rem">
            <div class="unfreeze_middle_content_title" v-if="
              visitorFrozenContentNew.visitorFrozen == 2 &&
              visitorFrozenContentNew.lifeTitle1 != undefined &&
              visitorFrozenContentNew.lifeTitle1 != ''
            ">
              {{ visitorFrozenContentNew.lifeTitle1 }}
            </div>
            <div v-html="visitorFrozenContentNew.lifeStory1" class="unfreeze_middle_content_text" v-if="
              visitorFrozenContentNew.visitorFrozen == 2 &&
              visitorFrozenContentNew.lifeStory1 != undefined &&
              visitorFrozenContentNew.lifeStory1 != ''
            "></div>
            <div class="unfreeze_middle_content_title" v-if="
              visitorFrozenContentNew.visitorFrozen == 2 &&
              visitorFrozenContentNew.lifeTitle2 != undefined &&
              visitorFrozenContentNew.lifeTitle2 != ''
            ">
              {{ visitorFrozenContentNew.lifeTitle2 }}
            </div>
            <div v-html="visitorFrozenContentNew.lifeStory2" class="unfreeze_middle_content_text" v-if="
              visitorFrozenContentNew.visitorFrozen == 2 &&
              visitorFrozenContentNew.lifeStory2 != undefined &&
              visitorFrozenContentNew.lifeStory2 != ''
            "></div>
            <img class="unfreeze_middle_img" :src="visitorFrozenContentNew.coverUrl" alt=""
              style="margin-top: 2rem; margin-left: 1rem" v-if="visitorFrozenContentNew.visitorFrozen == 2"
              mode="aspectFill" />
            <div class="v_template_imgs_a" v-if="visitorFrozenContentNew.visitorFrozen == 2">
              <div class="v_template_item_a" v-for="(item, i) in visitorFrozenContentNew.photoList" :key="i"
                style="margin-left: 1rem">
                <img class="iv_template_a" alt="" :src="item.photoUrl" mode="aspectFill" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button style="width: 10rem; margin-right: 1.5rem" plain @click="dialogUnfreezeCancel()">取消</el-button>
        <el-button class="dialog_button" style="
            background-color: #ff4a4a;
            border-color: #ff4a4a;
            color: #ffffff;
          " @click="dialogUnfreezeNo()">驳回</el-button>
        <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
          @click="dialogUnfreezeSave()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="photoAlbumData.photoCreated ? '新建相册' : '编辑相册'" :visible.sync="photoAlbumDialog"
      :destroy-on-close="true" :close-on-click-modal="false" :before-close="handleAlbumClose" width="75rem">
      <el-form :model="photoAlbumData" ref="photoAlbumData" label-width="10rem" :rules="photoAlbumRules">
        <el-form-item prop="name" label="相册名称：" class="search_item_a">
          <el-input v-model.trim="photoAlbumData.name" placeholder="请输入相册名称" style="width: 22rem" maxlength="8">
          </el-input>
        </el-form-item>
        <el-form-item prop="lookPms" label="查看权限：" class="search_item_a">
          <div class="v_photo_album_choice_all">
            <div class="v_photo_album_choice" @click="toChoicePms('1')">
              <img class="iv_choice_icon" v-if="photoAlbumData.lookPms == '1'"
                src="@/assets/images/space/iv_choice_yes.png" alt="" />
              <img class="iv_choice_icon" v-if="photoAlbumData.lookPms != '1'"
                src="@/assets/images/space/iv_choice_no.png" alt="" />
              <div class="v_photo_album_choice_text">仅自己可见</div>
            </div>
            <div class="v_photo_album_choice" @click="toChoicePms('2')">
              <img class="iv_choice_icon" v-if="photoAlbumData.lookPms == '2'"
                src="@/assets/images/space/iv_choice_yes.png" alt="" />
              <img class="iv_choice_icon" v-if="photoAlbumData.lookPms != '2'"
                src="@/assets/images/space/iv_choice_no.png" alt="" />
              <div class="v_photo_album_choice_text">
                所有管理员可见（当前 <span class="v_photo_album_choice_text_bule"> {{photoAlbumData.number}} </span>人）
              </div>
            </div>
            <div class="v_photo_album_choice" @click="toChoicePms('3')">
              <img class="iv_choice_icon" v-if="photoAlbumData.lookPms == '3'"
                src="@/assets/images/space/iv_choice_yes.png" alt="" />
              <img class="iv_choice_icon" v-if="photoAlbumData.lookPms != '3'"
                src="@/assets/images/space/iv_choice_no.png" alt="" />
              <div class="v_photo_album_choice_text">所有人可见（管理员及访客）</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="封面设置：" class="search_item_a">
          <div class="cover_upload_area_b">
            <OSSUpload :dmId="details.id" :type="8" @fileInfo="coverFileInfo" :imageUrl="photoAlbumData.coverUrl"
              v-if="toShowCover" :isChange="photoAlbumData.photoCreated?'1':'2'"></OSSUpload>
            <OSSUpload :dmId="details.id" :type="8" @fileInfo="coverFileInfo" :imageUrl="photoAlbumData.coverUrl"
              v-if="!toShowCover" :isChange="photoAlbumData.photoCreated?'1':'2'"></OSSUpload>
            <img class="iv_delete_photo" src="@/assets/images/space/iv_delete_photo.png" alt=""
              v-if="photoAlbumData.coverUrl != ''" @click="deletePhoto()">
          </div>
          <div style="color:#000000">照片格式为jpg或png，大小为10KB~10MB，图片尺寸为325×325</div>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="queryPhotoAlbum" style="width: 10rem">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OSSUpload from "@/components/OSSUpload";
import mixins from "./Mixins";
import axios from "axios";
import html2canvas from "html2canvas";
import {
  catchErr,
  roundAll,
  nowDate,
  seconds,
  updataLink,
} from "@/utils/utils";
import {
  _getAmBase64,
  _setPosterName,
  _editClaimCodeById,
  _setPosterNameCode,
} from "@/api/Common";
export default {
  components: { OSSUpload },
  mixins: [mixins],
  data() {
    return {
      qrcodeTitle: "",
      qrcodeLink: "",
      qrcodeMenuVisible: false,
      qrcodeMenuLeft: 0,
      qrcodeMenuTop: 0,
      //横版
      isDownBig: true,
      editADImageData: {
        currentIndex: "",
        name: "",
        amId: "",
        posterUrl: "",
        first: "",
        second: "",
        third: "",
        forth: "",
        loading: false,
      },
      isDown: false,
      ADImageVisible: false,
      ADImageEditVisible: false,
      resultData: '',

      //竖版
      isDownBigCode: true,
      claimCodeData: {
        currentIndex: "",
        name: "",
        amId: "",
        posterUrl: "",
        first: "",
        second: "",
        third: "",
        forth: "",
        loading: false,
      },
      isDownCode: false,
      ADImageVisibleCode: false,
      ADImageEditVisibleCode: false,
      resultDataCode: '',

      freezingVisitorText: "",

      isClaim: false,

      photoAlbumRules: {
        name: [{ required: true, message: "请输入相册名称", trigger: "blur" }],
        lookPms: [{ required: true, message: "", trigger: "blur" }],
      },
      toShowCover: true,
    };
  },
  computed: {
    details() {
      return this.SpaceManagement.spaceDetails.details;
    },
    photoAlbumDialog: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumDialog;
      },
      set: function (v) {
        this.PHOTOALBUMDIALOG(v);
      },
    },
    photoAlbumData: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumData;
      },
      set: function (v) {
        this.PHOTOALBUMDATA(v);
      },
    },
    visitorFrozenContentNew: {
      get: function () {
        return this.SpaceManagement.spaceDetails.visitorFrozenContentNew;
      },
      set: function (v) {
        this.VISITORFROZENCONTENTNEW(v);
      },
    },
    visitorFrozenContent: {
      get: function () {
        return this.SpaceManagement.spaceDetails.visitorFrozenContent;
      },
      set: function (v) {
        this.VISITORFROZENCONTENT(v);
      },
    },
    unfreezeDialog: {
      get: function () {
        return this.SpaceManagement.spaceDetails.unfreezeDialog;
      },
      set: function (v) {
        this.UNFREEZEDIALOG(v);
      },
    },
    freezingVisitorDialog: {
      get: function () {
        return this.SpaceManagement.spaceDetails.freezingVisitorDialog;
      },
      set: function (v) {
        this.FREEZINGVISITORDIALOG(v);
      },
    },
    qrcodeVisible: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisible;
      },
      set: function (v) {
        this.SETQRCODEVISIBLE(v);
      },
    },
    qrcodeVisibleClaimApp: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleClaimApp;
      },
      set: function (v) {
        this.SETQRCODEVISIBLECLAIMAPP(v);
      },
    },
    qrcodeVisibleClaimAll: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleClaimAll;
      },
      set: function (v) {
        this.SETQRCODEVISIBLECLAIMALL(v);
      },
    },
    qrcodeVisibleClaim: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleClaim;
      },
      set: function (v) {
        this.SETQRCODEVISIBLECLAIM(v);
      },
    },
    qrcodeVisibleDown: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDown;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWN(v);
      },
    },
    qrcodeVisibleDownClaimApp: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDownClaimApp;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWNCLAIMAPP(v);
      },
    },
    qrcodeVisibleDownClaimAll: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDownClaimAll;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWNCLAIMALL(v);
      },
    },
    qrcodeVisibleDownClaim: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDownClaim;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWNCLAIM(v);
      },
    },
    showOrdown: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showOrdown;
      },
      set: function (v) {
        this.TOSHOWPOSTER(v);
      },
    },
    showOrdownCode: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showOrdownCode;
      },
      set: function (v) {
        this.TOSHOWPOSTERCODE(v);
      },
    },
    showBgUrl: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showBgUrl;
      },
      set: function (v) {
        this.TOSHOWBGURL(v);
      },
    },
    showBgUrlCode: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showBgUrlCode;
      },
      set: function (v) {
        this.TOSHOWBGURLCODE(v);
      },
    },
    fontColor: {
      get: function () {
        return this.SpaceManagement.spaceDetails.fontColor;
      },
      set: function (v) {
        this.FONTCOLOR(v);
      },
    },
    fontColorCode: {
      get: function () {
        return this.SpaceManagement.spaceDetails.fontColorCode;
      },
      set: function (v) {
        this.FONTCOLORCODE(v);
      },
    },
    photoCategoryList() {
      return this.SpaceManagement.spaceDetails.photoCategoryList;
    },
    uploadState: {
      get: function () {
        return this.SpaceManagement.spaceDetails.uploadState;
      },
      set: function (v) {
        this.SETUPLOAD(v);
      },
    },
  },
  watch: {
    showOrdown: function (v) {
      if (v == 1) {
        this.isDownBig = true;
        this.editADImageData.currentIndex = 0;
        this.editADImageData.name =
          this.SpaceManagement.spaceDetails.details.name;
        this.editADImageData.amId =
          this.SpaceManagement.spaceDetails.details.id;
        this.editADImageData.first =
          this.SpaceManagement.spaceDetails.details.name;
        this.editADImageData.second = "";
        this.editADImageData.third = "";
        this.editADImageData.forth = "";
        this.isDown = false;
        this.getPosterName();
      } else if (v == 2) {
        this.isDownBig = false;
        this.editADImageData.currentIndex = 0;
        this.editADImageData.name =
          this.SpaceManagement.spaceDetails.details.name;
        this.editADImageData.amId =
          this.SpaceManagement.spaceDetails.details.id;
        this.editADImageData.first =
          this.SpaceManagement.spaceDetails.details.name;
        this.editADImageData.second = "";
        this.editADImageData.third = "";
        this.editADImageData.forth = "";
        this.isDown = true;
        this.getPosterName();
      }
    },

    showOrdownCode: function (v) {
      if (v == 1) {
        this.isDownBigCode = true;
        this.claimCodeData.currentIndex = 0;
        this.claimCodeData.name =
          this.SpaceManagement.spaceDetails.details.name;
        this.claimCodeData.amId = this.SpaceManagement.spaceDetails.details.id;
        this.claimCodeData.first =
          this.SpaceManagement.spaceDetails.details.name;
        this.claimCodeData.second = "";
        this.claimCodeData.third = "";
        this.claimCodeData.forth = "";
        this.isDownCode = false;
        this.getClaimCode();
      } else if (v == 2) {
        this.isDownBigCode = false;
        this.claimCodeData.currentIndex = 0;
        this.claimCodeData.name =
          this.SpaceManagement.spaceDetails.details.name;
        this.claimCodeData.amId = this.SpaceManagement.spaceDetails.details.id;
        this.claimCodeData.first =
          this.SpaceManagement.spaceDetails.details.name;
        this.claimCodeData.second = "";
        this.claimCodeData.third = "";
        this.claimCodeData.forth = "";
        this.isDownCode = true;
        this.getClaimCode();
      }
    },

    qrcodeVisible: function (v) {
      if (v) {
        this.qrcodeTitle = `${this.SpaceManagement.spaceDetails.details.name}`;
        this.getBase64URL(this.SpaceManagement.spaceDetails.details.wxAcodeUrl);
      }
    },
    qrcodeVisibleClaimApp: function (v) {
      if (v) {
        this.toSaveLogClaimApp();
        this.qrcodeTitle = `${this.SpaceManagement.spaceDetails.details.name}`;
        this.showClaimCodeUrl();
      }
    },
    qrcodeVisibleClaimAll: function (v) {
      if (v) {
        this.toSaveLogClaimAll();
        this.qrcodeTitle = `${this.SpaceManagement.spaceDetails.details.name}`;
        this.showClaimCodeUrlAll();
      }
    },
    qrcodeVisibleClaim: function (v) {
      if (v) {
        this.toSaveLogClaim();
        this.qrcodeTitle = `${this.SpaceManagement.spaceDetails.details.name}`;
        this.getBase64URL(
          this.SpaceManagement.spaceDetails.details.claimCodeUrl
        );
      }
    },
    qrcodeVisibleDown: function (v) {
      if (v) {
        this.isClaim = false;
        this.qrcodeVisible = true;
        this.toSaveLog();
        setTimeout(() => {
          this.exportQrcodePicTimer();
        }, 3000);
        setTimeout(() => {
          this.qrcodeVisible = false;
          this.qrcodeVisibleDown = false;
        }, 5000);
      }
    },
    qrcodeVisibleDownClaimApp: function (v) {
      if (v) {
        this.isClaim = true;
        this.qrcodeVisibleClaimApp = true;
        this.showClaimCodeUrl(true);
      }
    },
    qrcodeVisibleDownClaimAll: function (v) {
      if (v) {
        this.isClaim = true;
        this.qrcodeVisibleClaimAll = true;
        this.showClaimCodeUrlAll(true);
      }
    },
    qrcodeVisibleDownClaim: function (v) {
      if (v) {
        this.isClaim = true;
        this.qrcodeVisibleClaim = true;
        //console.log(v)
        //this.toSaveLogClaim();
        setTimeout(() => {
          this.exportQrcodePicTimerClaim();
        }, 3000);
        setTimeout(() => {
          this.qrcodeVisibleClaim = false;
          this.qrcodeVisibleDownClaim = false;
        }, 5000);
      }
    },
    qrcodeMenuVisible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeQrcodeMenuMenu);
        document.body.addEventListener("contextmenu", this.closeQrcodeMenuMenu);
      } else {
        document.body.removeEventListener("click", this.closeQrcodeMenuMenu);
        document.body.removeEventListener(
          "contextmenu",
          this.closeQrcodeMenuMenu
        );
      }
    },
  },
  filters: {
    remarkLength(v) {
      if (v) {
        return v.length;
      } else {
        return 0;
      }
    },
  },
  created() { },
  methods: {
    deletePhoto() {
      this.photoAlbumData.coverUrl = '';
    },
    //查看权限
    toChoicePms(item) {
      this.photoAlbumData.lookPms = item;
    },
    queryPhotoAlbum() {
      if (this.photoAlbumData.name == "") {
        this.$message.error("请输入相册名称");
        return
      }
      if (this.photoAlbumData.lookPms == '0') {
        this.$message.error("请设置查看范围");
        return
      }
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        name: this.photoAlbumData.name,
        showScope: this.photoAlbumData.lookPms,
      }
      if (this.photoAlbumData.coverUrl != "") {
        params.coverUrl = this.photoAlbumData.coverUrl
      }
      if (this.photoAlbumData.source != undefined) {
        params.source = this.photoAlbumData.source
      }
      if (!this.photoAlbumData.photoCreated) {
        params.id = this.photoAlbumData.id;
      }
      this.addOrEditPhotoCategory(params).then((res) => {
        console.log(res)
        if (res.status == 1000) {
          this.$message.success("操作成功");
          this.photoAlbumDialog = false;
          this.findPhotoCategory(this.SpaceManagement.spaceDetails.details.id)
        } else if (res.status == 1098) {
          this.showCo();
        } else if (res.status == 1086) {
          this.$message.error(res.message);
          this.photoAlbumDialog = false;
          this.findPhotoCategory(this.SpaceManagement.spaceDetails.details.id);
          this.findByIdAnother(this.SpaceManagement.spaceDetails.details.id).then((res) => {
            if (res.status == 1000) {

              if (res.data.fileVideoSizeUse == 0) {
                this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 0
              } else {
                this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = res.data.fileVideoSizeUse / res.data.fileSizeCount * 100
                if (this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef < 1) {
                  this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 1
                }
              }
              if (res.data.filePicSizeUse == 0) {
                this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 0
              } else {
                this.SpaceManagement.spaceDetails.details.filePicSizeUsef = res.data.filePicSizeUse / res.data.fileSizeCount * 100
                if (this.SpaceManagement.spaceDetails.details.filePicSizeUsef < 1) {
                  this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 1
                }
              }

              this.SpaceManagement.spaceDetails.details.fileSizeUse =
                res.data.fileSizeUse;
              this.SpaceManagement.spaceDetails.details.fileSizeCount =
                res.data.fileSizeCount;
              this.SpaceManagement.spaceDetails.details.fileSizeUseA =
                roundAll.roundFn(res.data.fileSizeUse / 1024 / 1024, 3);
              this.SpaceManagement.spaceDetails.details.fileSizeCountA =
                roundAll.roundFn(
                  res.data.fileSizeCount / 1024 / 1024 -
                  res.data.fileSizeUse / 1024 / 1024,
                  3
                );

              this.SpaceManagement.spaceDetails.details.fileVideoCount =
                res.data.fileVideoCount;
              this.SpaceManagement.spaceDetails.details.filePicCount =
                res.data.filePicCount;
              this.SpaceManagement.spaceDetails.details.viewCount =
                res.data.viewCount;

              if (res.data.uploadState == 1) {
                this.uploadState = false;
              } else {
                this.uploadState = true;
              }
              this.SpaceManagement.spaceDetails.details.claimState =
                res.data.claimState;

            } else if (res.status == 1098) {
              this.showCo();
            }
          });
        }
      });
    },
    handleAlbumClose(done) {
      done();
    },
    //上传
    coverFileInfo(file) {
      console.log(file);
      this.photoAlbumData.coverUrl = file[0].url;
      this.toShowCover = !this.toShowCover;
      console.log(this.photoAlbumData.coverUrl);
    },
    async getBase64URL(url) {
      let [err, res] = await catchErr(
        _getAmBase64({
          data: url,
        })
      );
      if (err) {
        this.$message.error(err || "错了哦，系统异常");
      } else if (res) {
        console.log(res);
        this.qrcodeLink = res.data;
      }
    },

    async toSaveLog() {
      let data = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        type: "TYPE_QRCODE_DOWNLOAD",
      };
      this.saveLog(data).then((res) => {
        console.log(res);
      });
    },

    async toSaveLogClaim() {
      let data = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        type: "TYPE_CLAIMCODEURL",
      };
      this.saveLog(data).then((res) => {
        console.log(res);
      });
    },

    async toSaveLogClaimApp() {
      let data = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        type: "TYPE_CLAIMCODEURL_APP",
      };
      this.saveLog(data).then((res) => {
        console.log(res);
      });
    },

    async toSaveLogClaimAll() {
      let data = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        type: "TYPE_CLAIMCODEURL_ALL",
      };
      this.saveLog(data).then((res) => {
        console.log(res);
      });
    },

    openQrcodeMenuMenu(e, index) {
      if (e.target.nodeName == "UL" || e.target.nodeName == "LI") {
        this.exportQrcodePicTimer();
        return;
      }
      if (index == 1) {
        this.qrcodeMenuLeft = e.layerX;
        this.qrcodeMenuTop = e.layerY - document.documentElement.scrollTop;
      } else {
        this.qrcodeMenuLeft = e.layerX + 135;
        this.qrcodeMenuTop =
          e.layerY + 110 - document.documentElement.scrollTop;
      }
      this.qrcodeMenuVisible = true;
      e.stopPropagation();
    },

    qrcodeDialogOpen() {},

    qrcodeDialogClose() {
      this.qrcodeTitle = "";
      this.qrcodeLink = "";
      this.qrcodeMenuVisible = false;
    },

    exportQrcodePicTimer() {
      this.closeQrcodeMenuMenu();
      setTimeout(() => {
        this.exportQrcodePic();
      });
    },

    exportQrcodePicTimerClaim() {
      this.closeQrcodeMenuMenu();
      setTimeout(() => {
        this.exportQrcodePicClaim();
      });
    },

    exportQrcodePic() {
      let _that = this;
      let getPixelRatio = function (context) {
        // 获取设备的PixelRatio
        var backingStore =
          context.backingStorePixelRatio ||
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio ||
          0.5;
        return (window.devicePixelRatio || 0.5) / backingStore;
      };
      //生成的图片名称
      let shareContent = document.getElementById("qrcodeExport");
      let width = shareContent.offsetWidth;
      let height = shareContent.offsetHeight;
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let scale = getPixelRatio(context); //将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。

      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      context.scale(1, 1);

      let opts = {
        y:
          document.documentElement.scrollTop +
          document.documentElement.offsetHeight * 0.15,
        scale: scale,
        canvas: canvas,
        width: width,
        height: height,
        dpi: window.devicePixelRatio,
        useCORS: true,
      };

      html2canvas(shareContent, opts).then(function (canvas) {
        context.imageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        let dataUrl = canvas.toDataURL("image/jpeg", 1.0);
        dataURIToBlob(dataUrl, callback);
      });

      let dataURIToBlob = function (dataURI, callback) {
        let binStr = atob(dataURI.split(",")[1]),
          len = binStr.length,
          arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        callback(new Blob([arr]));
      };

      let callback = function (src) {
        let url = window.URL.createObjectURL(src);
        let a = document.createElement("a");
        a.href = url;
        let name = "访问码-";
        if (_that.SpaceManagement.spaceDetails.details.name.length > 6) {
          name =
            name +
            _that.SpaceManagement.spaceDetails.details.name.substring(0, 6);
        } else {
          name = name + _that.SpaceManagement.spaceDetails.details.name;
        }
        console.log(nowDate.getNowDate());
        name = name + nowDate.getNowDate() + ".jpg";
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
      };
    },

    exportQrcodePicClaim() {
      let _that = this;
      let getPixelRatio = function (context) {
        // 获取设备的PixelRatio
        var backingStore =
          context.backingStorePixelRatio ||
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio ||
          0.5;
        return (window.devicePixelRatio || 0.5) / backingStore;
      };
      //生成的图片名称
      let shareContent = document.getElementById("qrcodeExportclaim");
      let width = shareContent.offsetWidth;
      let height = shareContent.offsetHeight;
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let scale = getPixelRatio(context); //将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。

      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      context.scale(1, 1);

      let opts = {
        y:
          document.documentElement.scrollTop +
          document.documentElement.offsetHeight * 0.15,
        scale: scale,
        canvas: canvas,
        width: width,
        height: height,
        dpi: window.devicePixelRatio,
        useCORS: true,
      };

      html2canvas(shareContent, opts).then(function (canvas) {
        context.imageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        let dataUrl = canvas.toDataURL("image/jpeg", 1.0);
        dataURIToBlob(dataUrl, callback);
      });

      let dataURIToBlob = function (dataURI, callback) {
        let binStr = atob(dataURI.split(",")[1]),
          len = binStr.length,
          arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        callback(new Blob([arr]));
      };

      let callback = function (src) {
        let url = window.URL.createObjectURL(src);
        let a = document.createElement("a");
        a.href = url;
        let name = "小程序认领码-";
        if (_that.SpaceManagement.spaceDetails.details.name.length > 6) {
          name =
            name +
            _that.SpaceManagement.spaceDetails.details.name.substring(0, 6);
        } else {
          name = name + _that.SpaceManagement.spaceDetails.details.name;
        }
        console.log(nowDate.getNowDate());
        name = name + nowDate.getNowDate() + ".jpg";
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
      };
    },

    closeQrcodeMenuMenu() {
      this.qrcodeMenuVisible = false;
    },

    closeAll() {
      this.qrcodeVisible = false;
      this.qrcodeVisibleDown = false;
    },

    closeAllClaimApp() {
      this.qrcodeVisibleClaimApp = false;
      this.qrcodeVisibleDownClaimApp = false;
    },
    closeAllClaimAll() {
      this.qrcodeVisibleClaimAll = false;
      this.qrcodeVisibleDownClaimAll = false;
    },
    closeAllClaim() {
      this.qrcodeVisibleClaim = false;
      this.qrcodeVisibleDownClaim = false;
    },

    async getPosterName(data) {
      const loading = this.$loading({
        lock: true,
        text: "正在生成背景",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let [err, res] = await catchErr(
        _setPosterName(
          {
            data: {
              id: this.editADImageData.amId,
              bgUrl: this.SpaceManagement.spaceDetails.showBgUrl,
              fontColor: this.SpaceManagement.spaceDetails.fontColor
            },
          },
          this.editADImageData.amId
        )
      );
      if (err) {
        loading.close();
        if (err.status == 1098) {
          this.$Confirm("纪念堂已失效，请返回纪念堂列表页面刷新", "提示", {
            type: "warning",
            showCancelButton: false,
          })
            .then(() => {
              window.opener = null;
              window.open("about:blank", "_top").close();
            })
            .catch(() => {
              window.opener = null;
              window.open("about:blank", "_top").close();
            });
        } else {
          this.$message.error(err || "错了哦，系统异常");
        }
      } else if (res) {
        console.log(res);
        if (!this.isDown) {
          loading.close();
          this.editADImageData.posterUrl = res.data.posterUrl;
          this.resultData = res.data;
          this.editADImageData.first =
            res.data.posterNames[0] != undefined ? res.data.posterNames[0] : "";
          this.editADImageData.second =
            res.data.posterNames[1] != undefined ? res.data.posterNames[1] : "";
          this.editADImageData.third =
            res.data.posterNames[2] != undefined ? res.data.posterNames[2] : "";
          this.editADImageData.forth =
            res.data.posterNames[3] != undefined ? res.data.posterNames[3] : "";
          this.ADImageVisible = true;
        }
        if (this.isDown) {
          let link = document.createElement("a");
          let url = res.data.posterUrl; //codeIMG  要下载的路径
          this.editADImageData.posterUrl = res.data.posterUrl;
          this.ADImageVisible = true;
          loading.close();
          // 这里是将url转成blob地址，

          axios({
            method: "POST",
            url: "/api/common/getUrlDataSource",
            data: {
              data: url,
            },
            responseType: "blob",
          }).then((response) => {
            link.href = URL.createObjectURL(response.data);
            let name = "横版海报-";
            if (this.SpaceManagement.spaceDetails.details.name.length > 6) {
              name =
                name +
                this.SpaceManagement.spaceDetails.details.name.substring(0, 6);
            } else {
              name = name + this.SpaceManagement.spaceDetails.details.name;
            }
            name = name + nowDate.getNowDate() + ".png";
            console.log(name);
            link.download = name;
            document.body.appendChild(link);
            link.click();
            this.ADImageVisible = false;
            this.showOrdown = 0;
          });

          return;
        }
      }
    },

    //竖版
    async getClaimCode() {
      const loading = this.$loading({
        lock: true,
        text: "正在生成背景",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let [err, res] = await catchErr(
        _setPosterNameCode(
          {
            data: {
              id: this.claimCodeData.amId,
              bgUrl: this.SpaceManagement.spaceDetails.showBgUrlCode,
              fontColor: this.SpaceManagement.spaceDetails.fontColorCode
            },
          },
          this.claimCodeData.amId
        )
      );
      if (err) {
        loading.close();
        if (err.status == 1098) {
          this.$Confirm(
            "纪念堂已退款成功，该纪念堂失效，请返回纪念堂列表页面刷新",
            "提示",
            {
              type: "warning",
              showCancelButton: false,
            }
          )
            .then(() => {
              window.opener = null;
              window.open("about:blank", "_top").close();
            })
            .catch(() => {
              window.opener = null;
              window.open("about:blank", "_top").close();
            });
        } else {
          this.$message.error(err || "错了哦，系统异常");
        }
      } else if (res) {
        console.log(res);
        if (!this.isDownCode) {
          loading.close();
          this.claimCodeData.posterUrl = res.data.posterUrl;
          this.resultDataCode = res.data;
          this.claimCodeData.first =
            res.data.posterNames[0] != undefined ? res.data.posterNames[0] : "";
          this.claimCodeData.second =
            res.data.posterNames[1] != undefined ? res.data.posterNames[1] : "";
          this.claimCodeData.third =
            res.data.posterNames[2] != undefined ? res.data.posterNames[2] : "";
          this.claimCodeData.forth =
            res.data.posterNames[3] != undefined ? res.data.posterNames[3] : "";
          this.ADImageVisibleCode = true;
        }
        if (this.isDownCode) {
          let link = document.createElement("a");
          let url = res.data.posterUrl; //codeIMG  要下载的路径
          this.claimCodeData.posterUrl = res.data.posterUrl;
          this.ADImageVisibleCode = true;
          loading.close();
          // 这里是将url转成blob地址，

          axios({
            method: "POST",
            url: "/api/common/getUrlDataSource",
            data: {
              data: url,
            },
            responseType: "blob",
          }).then((response) => {
            link.href = URL.createObjectURL(response.data);
            let name = "竖版海报-";
            if (this.SpaceManagement.spaceDetails.details.name.length > 6) {
              name =
                name +
                this.SpaceManagement.spaceDetails.details.name.substring(0, 6);
            } else {
              name = name + this.SpaceManagement.spaceDetails.details.name;
            }
            name = name + nowDate.getNowDate() + ".png";
            console.log(name);
            link.download = name;
            document.body.appendChild(link);
            link.click();
            this.ADImageVisibleCode = false;
            this.showOrdownCode = 0;
          });
          return;
        }
      }
    },

    edit_ADImage() {
      this.ADImageEditVisible = true;
      this.ADImageVisible = false;
    },

    edit_ADImage_another() {
      this.ADImageEditVisibleCode = true;
      this.ADImageVisibleCode = false;
    },

    getNewADImage() {
      this.editADImageData.first = this.editADImageData.first.trim();
      this.editADImageData.second = this.editADImageData.second.trim();
      this.editADImageData.third = this.editADImageData.third.trim();
      this.editADImageData.forth = this.editADImageData.forth.trim();
      if (
        this.editADImageData.first != "" ||
        this.editADImageData.second != "" ||
        this.editADImageData.third != "" ||
        this.editADImageData.forth != ""
      ) {
        this.setPosterName(this.editADImageData);
      } else {
        this.$message.error("文案不能为空");
      }
    },

    getNewADImageCode() {
      this.claimCodeData.first = this.claimCodeData.first.trim();
      this.claimCodeData.second = this.claimCodeData.second.trim();
      this.claimCodeData.third = this.claimCodeData.third.trim();
      this.claimCodeData.forth = this.claimCodeData.forth.trim();
      if (
        this.claimCodeData.first != "" ||
        this.claimCodeData.second != "" ||
        this.claimCodeData.third != "" ||
        this.claimCodeData.forth != ""
      ) {
        this.setPosterNameCode(this.claimCodeData);
      } else {
        this.$message.error("文案不能为空");
      }
    },

    getNewADImageCancel() {
      this.ADImageEditVisible = false;
      this.ADImageVisible = true;
      this.editADImageData.first =
        this.resultData.posterNames[0] != undefined ? this.resultData.posterNames[0] : "";
      this.editADImageData.second =
        this.resultData.posterNames[1] != undefined ? this.resultData.posterNames[1] : "";
      this.editADImageData.third =
        this.resultData.posterNames[2] != undefined ? this.resultData.posterNames[2] : "";
      this.editADImageData.forth =
        this.resultData.posterNames[3] != undefined ? this.resultData.posterNames[3] : "";
    },

    getNewADImageCancelCode() {
      this.ADImageEditVisibleCode = false;
      this.ADImageVisibleCode = true;
      this.claimCodeData.first =
        this.resultDataCode.posterNames[0] != undefined ? this.resultDataCode.posterNames[0] : "";
      this.claimCodeData.second =
        this.resultDataCode.posterNames[1] != undefined ? this.resultDataCode.posterNames[1] : "";
      this.claimCodeData.third =
        this.resultDataCode.posterNames[2] != undefined ? this.resultDataCode.posterNames[2] : "";
      this.claimCodeData.forth =
        this.resultDataCode.posterNames[3] != undefined ? this.resultDataCode.posterNames[3] : "";
    },

    closeADImage() {
      this.ADImageVisible = false;
      this.showOrdown = 0;
    },

    closeADImageCode() {
      this.ADImageVisibleCode = false;
      this.showOrdownCode = 0;
    },

    async setPosterName(data) {
      this.editADImageData.loading = true;
      let [err, res] = await catchErr(
        _setPosterName(
          {
            data: {
              id: this.editADImageData.amId,
              bgUrl: this.SpaceManagement.spaceDetails.showBgUrl,
              fontColor: this.SpaceManagement.spaceDetails.fontColor,
              posterNames: [
                data.first,
                data.second,
                data.third,
                data.forth,
              ].filter((item) => item != ""),
            },
          },
          this.editADImageData.amId
        )
      );
      if (err) {
        this.editADImageData.loading = false;
        this.$message.error(err || "错了哦，系统异常");
      } else if (res) {
        this.editADImageData.loading = false;
        this.editADImageData.posterUrl = res.data.posterUrl;
        this.resultData = res.data;
        this.editADImageData.first =
          res.data.posterNames[0] != undefined ? res.data.posterNames[0] : "";
        this.editADImageData.second =
          res.data.posterNames[1] != undefined ? res.data.posterNames[1] : "";
        this.editADImageData.third =
          res.data.posterNames[2] != undefined ? res.data.posterNames[2] : "";
        this.editADImageData.forth =
          res.data.posterNames[3] != undefined ? res.data.posterNames[3] : "";
        this.ADImageEditVisible = false;
        this.ADImageVisible = true;
        this.$message.success("操作成功");
      }
    },

    async setPosterNameCode(data) {
      this.claimCodeData.loading = true;
      let [err, res] = await catchErr(
        _setPosterNameCode(
          {
            data: {
              id: this.claimCodeData.amId,
              bgUrl: this.SpaceManagement.spaceDetails.showBgUrlCode,
              fontColor: this.SpaceManagement.spaceDetails.fontColorCode,
              posterNames: [
                data.first,
                data.second,
                data.third,
                data.forth,
              ].filter((item) => item != ""),
            },
          },
          this.claimCodeData.amId
        )
      );
      if (err) {
        this.claimCodeData.loading = false;
        this.$message.error(err || "错了哦，系统异常");
      } else if (res) {
        this.claimCodeData.loading = false;
        this.claimCodeData.posterUrl = res.data.posterUrl;
        this.resultDataCode = res.data;
        this.claimCodeData.first =
          res.data.posterNames[0] != undefined ? res.data.posterNames[0] : "";
        this.claimCodeData.second =
          res.data.posterNames[1] != undefined ? res.data.posterNames[1] : "";
        this.claimCodeData.third =
          res.data.posterNames[2] != undefined ? res.data.posterNames[2] : "";
        this.claimCodeData.forth =
          res.data.posterNames[3] != undefined ? res.data.posterNames[3] : "";
        this.ADImageEditVisibleCode = false;
        this.ADImageVisibleCode = true;
        this.$message.success("操作成功");
      }
    },

    handleFreezingVisitorClose(done) {
      done();
    },

    dialogFreezingVisitorTextCancel() {
      this.freezingVisitorText = "";
      this.freezingVisitorDialog = false;
    },

    //访问码冻结成功弹出框确定
    dialogFreezingVisitorTextSave() {
      if (this.freezingVisitorText == "") {
        this.$message.error("请填写冻结内容");
        return;
      }
      this.editVisitorFrozenById({
        id: this.$route.query.id,
        status: 1,
        remark: this.freezingVisitorText,
      }).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("访问码冻结成功");
          this.freezingVisitorText = "";
          this.refreshHalf(2);
        }
      });
    },

    //只更新头部
    refreshHalf(number) {
      this.findByIdHalf(this.$route.query.id).then((res) => {
        if (number == 2) {
          this.freezingVisitorDialog = false;
        }
      });
    },

    handleUnfreezeClose(done) {
      this.visitorFrozenContent = "";
      this.visitorFrozenContentNew = "";
      done();
    },

    dialogUnfreezeCancel() {
      this.unfreezeDialog = false;
      this.visitorFrozenContent = "";
      this.visitorFrozenContentNew = "";
    },

    dialogUnfreezeNo() {
      this.editVisitorFrozenById({
        id: this.$route.query.id,
        status: 3,
        remark: this.visitorFrozenContentNew.visitorFrozenRemark,
      }).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("驳回成功");
          this.visitorFrozenContent = "";
          this.visitorFrozenContentNew = "";
          this.unfreezeDialog = false;
          this.refreshHalf(3);
        }
      });
    },

    dialogUnfreezeSave() {
      this.editVisitorFrozenById({
        id: this.$route.query.id,
        status: 4,
      }).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("解冻成功");
          this.visitorFrozenContent = "";
          this.visitorFrozenContentNew = "";
          this.unfreezeDialog = false;
          this.refreshHalf(3);
        }
      });
    },

    showCo() {
      this.$Confirm("纪念堂已失效，请返回纪念堂列表页面刷新", "提示", {
        type: "warning",
        showCancelButton: false,
      })
        .then(() => {
          window.opener = null;
          window.open("about:blank", "_top").close();
        })
        .catch(() => {
          window.opener = null;
          window.open("about:blank", "_top").close();
        });
    },
    //获取认领码-APP
    showClaimCodeUrl(download, url) {
      if(download && url){
        this.downloadClaimCodeUrl(url, false, "APP");
      }else{
        this.getClaimCodeUrl(this.$route.query.id).then((res) => {
          if (res.status == 1000) {
            if(download){
              this.downloadClaimCodeUrl(res.data, true, "APP");
            }else{
              this.qrcodeLink = res.data;
            }
          }
        });
      }
    },    
    //获取认领码
    showClaimCodeUrlAll(download, url) {
      if(download && url){
        this.downloadClaimCodeUrl(url, false, "ALL");
      }else{
        this.getClaimCodeUrlAll(this.$route.query.id).then((res) => {
          if (res.status == 1000) {
            if(download){
              this.downloadClaimCodeUrl(res.data, true, "ALL");
            }else{
              this.qrcodeLink = res.data;
            }
          }
        });
      }
    },
    downloadClaimCodeUrl(url, autoClose, type){
      axios({
        method: "POST",
        url: "/api/common/getUrlDataSource",
        data: {
          data: url,
        },
        responseType: "blob",
      }).then((response) => {
        let link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        let name = "APP认领码-";
        if(type == "ALL"){
          name = "认领码-";
        }
        if (this.SpaceManagement.spaceDetails.details.name.length > 6) {
          name = name + this.SpaceManagement.spaceDetails.details.name.substring(0, 6);
        } else {
          name = name + this.SpaceManagement.spaceDetails.details.name;
        }
        name = name + nowDate.getNowDate() + ".png";
        link.download = name;
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        if(autoClose){
          setTimeout(() => {
            if(type == "ALL"){
              this.qrcodeVisibleClaimAll = false;
              this.qrcodeVisibleDownClaimAll = false;
            }else{
              this.qrcodeVisibleClaimApp = false;
              this.qrcodeVisibleDownClaimApp = false;
            }
          }, 3000);
        }
      });
    }
  },
};
</script>

<style lang="stylus" scoped>
.space_dialog {
  .dialog_ADImage, .dialog_ADImage_edit {
    .ADImage {
      width: 800px;
      height: 450px;
      margin: auto;
      margin-bottom: 30px;
    }

    .ADImage_btns {
      margin-top: 30px;
      text-align: center;

      .el-button {
        width: 100px;
        margin: 0 20px;
        padding: 12px 0;
      }
    }

    .dialog_ADImage_edit_input {
      width: 400px;
    }
  }

  .dialog_ADImage_code, .dialog_ADImage_edit_code {
    .ADImage {
      width: 330px;
      height: 485px;
      margin: auto;
      margin-bottom: 30px;
    }

    

    .ADImage_btns {
      margin-top: 30px;
      text-align: center;

      .el-button {
        width: 100px;
        margin: 0 20px;
        padding: 12px 0;
      }
    }

    .dialog_ADImage_edit_input {
      width: 400px;
    }
  }

  .cemetery_use {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
  }

  .cemetery_use_title_a {
    font-size: 14px;
    font-weight: 400;
    color: #040300;
    width: 120px;
  }

  .search_input_big {
    width: 220px;
    position: relative;
  }

  .search_input_big >>> .el-textarea__inner {
    font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;
    color: #000000;
  }

  .search_input_big_number_b {
    position: absolute;
    right: 130px;
    bottom: 8px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
  }

  .search_input_big_number_a {
    color: #000000;
    font-size: 14px;
  }

  .unfreeze_title_all {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .unfreeze_title_all_text {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #040300;
  }

  .unfreeze_title_search_input_another {
    margin-left: 10px;
    width: 1138px;
    min-height: 40px;
    line-height: 28px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 66px;
    font-weight: 400;
    color: #000000;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 6px;
    padding-bottom: 6px;
    position: relative;
  }

  .search_input_big_number_another {
    position: absolute;
    right: 10px;
    bottom: 6px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
    line-height: 28px;
  }

  .unfreeze_middle {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
  }

  .unfreeze_middle_title {
    font-size: 14px;
    font-weight: 400;
    color: #040300;
  }

  .unfreeze_middle_content {
    width: 500px;
    height: 522px;
    margin-left: 10px;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    overflow: auto;
  }

  .unfreeze_middle_content_title {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
  }

  .unfreeze_middle_content_text {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    margin-left: 10px;
  }

  .unfreeze_middle_img {
    width: 80px;
    height: 80px;
  }

  .v_template_imgs_a {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .v_template_item_a {
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
    }

    .iv_template_a {
      width: 80px;
      height: 80px;
    }
  }

  .v_photo_album_choice_all {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .v_photo_album_choice {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .v_photo_album_choice_text {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    margin-right: 20px;
  }

  .v_photo_album_choice_text_bule {
    font-size: 14px;
    font-weight: 400;
    color: #2C90FF;
  }

  .iv_choice_icon {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }

  .search_item_a >>>.el-form-item__label {
    color: #040300;
  }
}
</style>

<style lang="stylus">

.cover_upload_area_b {
  height: 250px;
  display: flex;
  flex-direction: row;
  position: relative;
  .cover {
    width: 250px;
    height: 250px;
    display: block;
  }
  .iv_delete_photo {
    width:29px;
    height:29px;
    position: absolute;
    left:236px;
    top:-15px;
    cursor: pointer;
  }
}

.cover_upload_area_b .coverUrlBorder {
  .el-upload {
    border: 0;

    img {
      width: 250px;
      height: 250px;
    }
  }
}

.cover_upload_area_b .coverUrlBorder {
  .el-upload {
    border: 0;
    cursor: not-allowed;

    img {
      width: 250px;
      height: 250px;
    }
  }
}

.cover_upload_area_b .avatar-uploader {
  width: 250px !important;
  height: 250px !important;
  border-radius: 10px;

  .el-upload {
    position: relative;
    // width: 220px;
    height: 250px;
    border: 1px dashed #D9D9D9;
    border-radius: 10px;

    img{
      border-radius: 10px;
    }
  }

  .el-upload:hover {
    border-color: #409EFF;
  }

  .v_avatar-uploader_bottom {
    position: absolute;
    bottom:0;
    left:0;
    right:0;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    width:250px;
    height: 35px;
    line-height:35px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3)
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    // background: #000000;
    // opacity: 0.3;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 250px;
    height: 250px;
    text-align: center;

    img {
      position: absolute;
      left: 100px;
      top: 87px;
      width: 50px;
      height: 50px;
    }

    .iv_two {
      position: absolute;
      left: 100px;
      top: 77px;
      width: 50px;
      height: 50px;
    }

    p {
      position: absolute;
      left: 101px;
      top: 147px;
      font-size: 12px;
      font-weight: 400;
      color: #B7B7B7;
      height: 17px;
      line-height: 17px;

      span {
        color: #3A81FF;
      }
    }

    .v_text_one {
      position: absolute;
      left: 79px;
      top: 137px;
      font-size: 12px;
      font-weight: 400;
      color: #B7B7B7;
      height: 17px;
      line-height: 17px;

      span {
        color: #949494;
      }
    }

    .v_text_two {
      position: absolute;
      left: 89px;
      top: 157px;
      font-size: 12px;
      font-weight: 400;
      color: #B7B7B7;
      height: 17px;
      line-height: 17px;

      span {
        color: #949494;
      }

      .v_text_three {
        margin-left:2px;
        font-size: 16px;
        color:#2C90FF;
      }
    }
  }

  .avatar {
    width: 250px;
    height: 250px;
    display: block;
    overflow: hidden;
    object-fit: contain;
  }

  .cover {
    width: 72px;
    height: 96px;
    display: block;
  }
}

.qrcodeClass {
  .el-dialog {
    height: 360px;
    border-radius: 8px;
  }

  .el-dialog__header {
    padding: 0;
    height: 0;
    line-height: 0;
    border-bottom: 0;
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}

#qrcode {
  margin: 0 auto;
  width: 141px;
  height: 142px;
  padding-top: 11px;
}

#qrcodeExport {
  height: 360px;

  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  .qrcodeTitle {
    font-size: 24px;
    font-weight: 500;
    color: rgba(44, 43, 41, 1);
    margin: 0 auto;
    padding: 20px 0 20px;
    text-align: center;
    width: 320px;
    line-height: 30px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .qrcodeTitlea {
    font-size: 18px;
    font-weight: 500;
    color: rgba(44, 43, 41, 1);
    margin: 0 auto;
    padding: 20px 0 20px;
    text-align: center;
    width: 320px;
    line-height: 30px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .qrcodeDetail {
    font-size: 18px;
    text-align: center;
    padding: 20px 0 20px;
  }

  .qrcodePic {
    width: 170px;
    height: 164px;
    background: url('~@/assets/images/space/qrcode.png') no-repeat scroll left center / 170px 164px;
    margin: 40px auto 0 auto;
  }

  .qrcodePica {
    width: 170px;
    height: 164px;
    background: url('~@/assets/images/space/qrcode.png') no-repeat scroll left center / 170px 164px;
    margin: 0 auto 0 auto;
  }

  .qrcodeMenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    width: 92px;

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      user-select: none;

      &:hover {
        background: #eee;
      }
    }
  }
}

#qrcodeExportclaim,.qrcodeExportclaim {
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .qrcodeTitle {
    font-size: 24px;
    font-weight: 500;
    color: rgba(44, 43, 41, 1);
    margin: 0 auto;
    padding: 20px 0 20px;
    text-align: center;
    width: 320px;
    line-height: 30px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .qrcodeTitlea {
    font-size: 18px;
    font-weight: 500;
    color: rgba(44, 43, 41, 1);
    margin: 0 auto;
    padding: 20px 0 20px;
    text-align: center;
    width: 320px;
    line-height: 30px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .qrcodeDetail {
    font-size: 18px;
    text-align: center;
    padding: 20px 0 20px;
  }

  .qrcodePic {
    width: 170px;
    height: 164px;
    background: url('~@/assets/images/space/qrcode.png') no-repeat scroll left center / 170px 164px;
    // margin: 40px auto 0 auto;
  }

  .qrcodePica {
    width: 170px;
    height: 164px;
    background: url('~@/assets/images/space/qrcode.png') no-repeat scroll left center / 170px 164px;
    margin: 0 auto 0 auto;
  }

  .qrcodeMenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    width: 92px;

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      user-select: none;

      &:hover {
        background: #eee;
      }
    }
  }
}

.qrcodeButton {
  position: absolute;
  bottom: -90px;
  left: 175px;
  width: 50px;
  height: 50px;
  background: url('~@/assets/images/space/close.png') no-repeat scroll left center / 50px 50px;
  cursor: pointer;
}

.qrcodeRadio {
  position: absolute;
  width: 15px;
  height: 15px;
  background: url('~@/assets/images/space/radio.png') no-repeat scroll left center / 15px 15px;
  margin: 10px;
}

.qrcodeRadio.upLeft {
  top: 0;
  left: 0;
}

.qrcodeRadio.upRight {
  top: 0;
  right: 0;
}

.qrcodeRadio.downLeft {
  bottom: 0;
  left: 0;
}

.qrcodeRadio.downRight {
  bottom: 0;
  right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceDetails/components/SpaceTab.vue